export const state = {
  files: [],
  file: {},
}
